<script lang="ts">
  import { Icon } from '@shared/ui/icon';

  import ViewerButton from './btn.svelte';

  export let size: 'sm' | 'md' | 'lg' = 'md';
</script>

<ViewerButton {size} on:click>
  <div class="relative h-5 w-5">
    <div
      class="
        absolute
        -translate-y-2.5
        translate-x-2.5
        scale-125
          transition-transform
          group-hover/btn:-translate-y-[8.5px]
          group-hover/btn:translate-x-[8.5px]
          group-hover/btn:scale-[115%]
      "
    >
      <Icon name="arrowsOutUpRight" />
    </div>
    <div
      class="
        absolute
        -translate-x-2.5
        translate-y-2.5
        scale-125
          transition-transform
          group-hover/btn:-translate-x-[8.5px]
          group-hover/btn:translate-y-[8.5px]
          group-hover/btn:scale-[115%]
      "
    >
      <Icon name="arrowsOutDownLeft" />
    </div>
  </div>
</ViewerButton>
